import styled from 'styled-components';

import { Wrapper as AddToWishList } from '../Controls/AddToWishList/styles';
import { Wrapper as CloseCard } from '../Controls/CloseCards/styles';
import { Wrapper as WrapperMapView } from '../Mapview/styles';
import { Wrapper as FeatureLabel } from '../Labels/styles';
import { Wrapper as Gallery, Photos } from '../Gallery/styles';
import { Wrapper as Tags } from '../Tags/styles';
import { mediaMin } from '@spa/shared/theme';

export const WrapperLink = styled.div`
  position: relative;
  display: block;
  max-width: 360px;
  padding-bottom: ${props => props.theme.space(3)};
  text-decoration: none;
  cursor: pointer;
  flex: 1;

  a {
    text-decoration: none;
  }

  ${mediaMin.mediumBreakpoint`
    ${props =>
      !props.isMap &&
      `
        width: 100%;
      `}
  `}

  ${mediaMin.smallBreakpoint`
    max-width: 100%;
  `}

  ${props =>
    props.isMap &&
    `
      width: ${props.isMobile ? '346px' : '285px'}
    `}

  & > * {
    text-decoration: none;
  }

  ${AddToWishList} {
    position: absolute;
    top: 11px;
    right: 11px;
  }

  ${WrapperMapView} {
    ${AddToWishList} {
      right: 11px;
    }
  }

  ${CloseCard} {
    ${props =>
      props.isMap &&
      `
      position: absolute;
      top: 11px;
      left: 11px;
    `}
  }

  ${Gallery} {
    ${props =>
      props.isMap &&
      `
        margin-bottom: 0;
    `}

    ${FeatureLabel} {
      position: absolute;
      bottom: 0;

      ${props =>
        props.isMap &&
        !props.isMobile &&
        `
        border-radius: 0px;
      `}

      ${props =>
        props.isMobile &&
        `
        right: 0;
        border-bottom-right-radius: 12px;
      `}

      ${props =>
        props.isMobile &&
        props.isUniresidences &&
        `
        background-color:  ${props.theme.labels.uniResidencesBackground};
      `}

      ${props =>
        props.isMobile &&
        props.isMap &&
        `
        border-bottom-right-radius: 0px;
      `}
    }
  }

  ${Photos} {
    height: 240px;

    ${props =>
      props.isMap &&
      `
      width: ${props.isMobile ? '160px' : '287px'};
      min-width: ${props.isMobile ? 'auto' : '260px'};
      height: 160px;
    `}
  }

  ${Tags} {
    z-index: 1;
  }
`;

export const Title = styled.a`
  p,
  h2 {
    font-family: IntervalNextReg, sans-serif;
    font-size: ${props => props.theme.rem(18)};
    line-height: ${props => props.theme.rem(22)};
    font-weight: 600;
    color: ${props => props.theme.card.primaryTextColor};
    margin-bottom: ${props => props.theme.space(3)};
  }
`;

export const FromDate = styled.p`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(19)};
  font-weight: 500;
  color: ${props => props.theme.card.neighbourhoodIconColor};
  margin-bottom: ${props => props.theme.space(2)};
`;

export const Price = styled.div`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(17)};
  font-weight: 400;
  color: ${props => props.theme.card.thirdColor};
  margin-right: ${props => props.theme.space(3)};

  span {
    font-family: IntervalNextReg, sans-serif;
    font-size: ${props => props.theme.rem(22)};
    font-weight: 600;
    color: ${props => props.theme.card.primaryTextColor};
    margin: 0 2px 0 5px;

    &.old__price {
      color: ${props => props.theme.colors.redPrimary};
      font-size: ${props => props.theme.rem(16)};
      text-decoration-line: line-through;
    }
  }
`;

export const InfoWrapper = styled.div`
  padding: ${props => props.theme.space(1)} ${props => props.theme.space(3)} ${props => props.theme.space(3)};

  ${props =>
    props.isMobile &&
    `
      padding: ${props.theme.space(3)} ${props.theme.space(2)};
    `}
`;

export const Typology = styled.span`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(12)};
  line-height: ${props => props.theme.rem(15)};
  font-weight: 400;
  margin-top: ${props => props.theme.space(4)};
  color: ${props => props.theme.card.thirdColor};
`;

export const BillsIncluded = styled.span`
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(17)};
  color: ${props => props.theme.card.billsIncludedColor};
`;

export const PriceBillsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  color: ${props => props.theme.card.thirdColor};
  flex-wrap: wrap;
`;

export const LabelsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.space(2)};
  margin-bottom: ${props => props.theme.space(2)};
`;

export const HomepageTag = styled.span`
  display: flex;
  align-items: center !important;
  min-width: 30px;
  height: 22px;
  background: #f6f6f6;
  color: #224251;
  padding: 0 ${props => props.theme.space(2)};
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(14)};
  color: ${props => props.theme.card.primaryTextColor};
  border-radius: 4px;
`;
